export const en = {
    youHere: 'You here'
}